import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import '../../css/frontend/projects-page.css';

export default function Projects() {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>SpaceTime Community | Projects</title>
                <meta
                    name="description"
                    content="Projects — coming soon."
                />
                <meta property="og:title" content="SpaceTime | Projects" />
                <meta property="og:url" content="https://spacetime.community/projects" />
            </Helmet>

            <div className="projects-page">
                {/* Header (optional, hidden for now) */}
                {/*<header className="projects-hero">
                    <h1 className="projects-title">{t('Projects')}</h1>
                </header>*/}

                {/* Body */}
                <main className="projects-body">
                    <div className="coming-soon" aria-label="Coming soon">
                        <span className="question-mark" aria-hidden="true">?</span>
                        <p className="coming-soon-text">{t('coming_soon_projects')}</p>
                    </div>
                </main>
            </div>
        </>
    );
}
